import React, { Component, PureComponent } from 'react';
import { connect } from "react-redux";
import Modal from 'react-modal';
import ReactTable from 'react-table';
import Analytics from 'APP_ROOT/services/analytics';
import ProgressSpinnerSmall from '../../../common/ProgressSpinnerSmall';
import TagsUtil, {TAG_ACTIONS} from '../../../common/tagsUtils';
import TagPermissions from '../../../common/tagsPermissions';
import { DispatchHelpers, Selectors, TAG_TYPES, TAG_USER_ROLES, TAG_USER_TYPES, TAG_COLORS } from '../../../../data/tags';
import TagsTreeView from '../../../TagsTreeView';
import TagTypesDropDown from '../../../TagTypesDropDown';
import { strings } from '../../../../localization';
import ConfirmDialog from '../../../common/ConfirmDialog';
import ProgressOverlay from '../../../common/ProgressOverlay';
import Color from '../../dashboard/ResourceDetails/Geofence/Attributes/Color/Color';
import EditableLabel from '../../../EditableLabel';
import TagRolesDropDown from '../../../TagRolesDropDown';
import InfoTooltip from '../../../InfoTooltip';

const EDITING_TAG_PROP = {
    NONE: 'none',
    ALL: 'all',
    NAME: 'name',
    TYPE: 'type',
    COLOR: 'color',
    RAVENS: 'ravens',
    USERS: 'users'
}

const SUBTAGS_ARROW_WIDTH = 24.53; // Width of the arrow next to tags withh subtags in the list

class TagsPage extends Component {

    state = {
        dataSet: false,

        isActionModalOpen: false,

        currentTag: undefined,

        editingCurrentTagProp: EDITING_TAG_PROP.NONE,

        expanded: {}, // for react-table
        filters: [], // for react-table

        users: undefined, // For modal's users list
        ravens: undefined, // For modal's ravens list
        tags: undefined, // For modal's tags list
        filteredTags: undefined, 

        availableRavens: undefined, // For modal's ravens list
        usersKeyword: '', // For modal's users filter
        ravensKeyword: '', // For modal's ravens filter

        errorMessage: '',
        successMessage: '',

        validationErrors: [],

        confirmDialog: null
    }

    usersListRef = React.createRef();

    componentDidMount() {
        Analytics.pageView();

        if(this.props.tags && this.props.ravens && this.props.users){
            this.setData();
        }
    }

    componentDidUpdate(prevProps) {

        if(!this.state.dataSet && this.props.tags && this.props.ravens && this.props.users){
            this.setData();
        }

        if((this.props.editingTag && !prevProps.editingTag) || 
           (this.props.editingTag && prevProps.editingTag && this.props.editingTag.tagId !== prevProps.editingTag.tagId)){
            this.setState({currentTag: this.props.editingTag});
        }

        if(this.state.validationErrors.length > 0){
            const fieldToFocus = document.querySelector(`.tag-action-modal #tag-${this.state.validationErrors[0].field}`);
            if(fieldToFocus){
                fieldToFocus.focus();
            }
        }        
    }

    setData = () => {
        if(!this.props.tagsInheritedUsersAreSet){
            return;
        }

        TagPermissions.setData(this.props.user, {tags: this.props.tags, users: this.props.users, ravens: this.props.ravens});

        const tags = TagPermissions.getUserTags(this.props.user, this.props.accountDetails, this.props.tags);

        const users = TagPermissions.getUserUsers(this.props.user, this.props.accountDetails, this.props.users, tags, true, true);

        const ravens = TagPermissions.getUserRavens(this.props.user, this.props.accountDetails, this.props.ravens, tags);

        this.setState({
            users,
            ravens,
            tags,
            filteredTags: this.filterTags(tags, this.state.filters),
            dataSet: true
        });

        // When the page is loaded, the root tag(s) are expanded by default
        if(Object.keys(this.state.expanded).length === 0){
            const defaultExpanded = this.getExpanded(tags, []);
            this.setState({expanded: defaultExpanded});
        }
    }
    
    setAvailableRavens = (parentTagRavens) => {
        // tag.ravens is an array of objects with ravenUuid and vehicle properties and not the full raven object
        // So we need to find the full raven object from the raven list
        const availableRavens = parentTagRavens.map(tagRaven => {
            return this.state.ravens.find(raven => tagRaven.ravenUuid === raven.ravenUuid);
        }).filter(raven => raven);

        this.setState({availableRavens});
    }

    requestEditingProp = (prop) => {
        this.setState({editingCurrentTagProp: prop});
    }

    cancelEditingProp = () => {
        this.setState({editingCurrentTagProp: EDITING_TAG_PROP.NONE});
    }

    updateCurrentTagName = (name) => {
        
        const isNewTag = !this.state.currentTag.tagId;

        if(isNewTag){
            this.setState({currentTag: {...this.state.currentTag, name}});
            return;
        }

        const editedTag = {...this.state.currentTag, name};
        if(!this.validateTag(editedTag)){
            return;
        }

        this.setState({errorMessage: '', successMessage: ''});

        this.props.updateTagName(editedTag.tagId, name)
        .then(() => {
            this.setState({
                currentTag: editedTag,
                successMessage: strings.formatString(strings.tags_save_edits_success, strings.tags_name_label)
            });
        })
        .catch((err) => {
            console.error("tagsPage: error updating tag name", err);
            this.setState({errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.EDIT, strings.tags_name_label)});
        })
        .finally(() => {
            this.setState({editingCurrentTagProp: EDITING_TAG_PROP.NONE});
        });
    }

    updateCurrentTagType = (selectedType) => {
        
        const isNewTag = !this.state.currentTag.tagId;

        if(isNewTag){
            this.setState({currentTag: {...this.state.currentTag, type: selectedType}});
            return;
        }

        this.setState({errorMessage: '', successMessage: ''});

        this.props.updateTagType(this.state.currentTag.tagId, selectedType)
        .then(() => {
            this.setState({
                currentTag: {...this.state.currentTag, type: selectedType},
                successMessage: strings.formatString(strings.tags_save_edits_success, strings.tags_type_label)
            });
        })
        .catch((err) => {
            console.error("tagsPage: error updating tag type", err);
            this.setState({errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.EDIT, strings.tags_type_label)});
        })
        .finally(() => {
            this.setState({editingCurrentTagProp: EDITING_TAG_PROP.NONE});
        });
    }

    updateCurrentTagColor = (selectedColor) => {
        const isNewTag = !this.state.currentTag.tagId;

        if(isNewTag){
            this.setState({currentTag: {...this.state.currentTag, style: {color: selectedColor}}});
            return;
        }

        this.setState({errorMessage: '', successMessage: '', editingCurrentTagProp: EDITING_TAG_PROP.COLOR});

        this.props.updateTagColor(this.state.currentTag.tagId, selectedColor)
        .then(() => {
            this.setState({
                currentTag: {...this.state.currentTag, style: {color: selectedColor}},
                successMessage: strings.formatString(strings.tags_save_edits_success, strings.tags_color_label)
            });
        })
        .catch((err) => {
            console.error("tagsPage: error updating tag color", err);
            this.setState({errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.EDIT, strings.tags_color_label)});
        })
        .finally(() => {
            this.setState({editingCurrentTagProp: EDITING_TAG_PROP.NONE});
        });
    }

    updateCurrentTagParent = (selectedTagsIds) => {
        const currentTag = this.state.currentTag;

        const isNewTag = !currentTag.tagId;

        if(isNewTag){

            const newParentTagId = selectedTagsIds[0]; // There should be only one item in the list anyway
            const newParentTag = this.state.tags.find(tag => tag.tagId === newParentTagId);

            TagsUtil.changeTagParent(currentTag, newParentTag);

            this.setAvailableRavens(newParentTag.ravens);

            this.setState({
                currentTag
            });

            return;
        }

        // A tag's parent cannot be changed after it's created
    }

    addUserToCurrentTag = (user) => {
        const currentTag = this.state.currentTag;

        const isNewTag = !currentTag.tagId;

        if(isNewTag){
            currentTag.users.push({
                userId: user.userId, 
                role: TAG_USER_ROLES.GUEST,
                email: user.email,
                type: TAG_USER_TYPES.OWN_USER
            });

            this.setState({ currentTag });
            return;
        }

        this.setState({ errorMessage: null, successMessage: null, editingCurrentTagProp: EDITING_TAG_PROP.USERS });

        this.props.addTagUser(currentTag.tagId, user, TAG_USER_ROLES.GUEST)
        .then((updatedTag) => {

            const updatedTagSubTags = this.state.tags.filter(tag => tag.ancestors.includes(updatedTag.tagId) && tag.tagId !== updatedTag.tagId);
            
            TagPermissions.addTagToUser(user, updatedTag, updatedTagSubTags);
            
            this.setState({
                currentTag: updatedTag,
                successMessage: strings.formatString(strings.tags_assign_success, user.email, currentTag.name)
            });
        })
        .catch(err => {
            console.error("tagsPage: error adding user to tag", err);
            this.setState({ errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.ASSIGN_USER, currentTag.name, user.email) });
        })
        .finally(() => {
            this.setState({ editingCurrentTagProp: EDITING_TAG_PROP.NONE });
        });
    }

    removeUserFromCurrentTag = (user) => {
        const currentTag = this.state.currentTag;

        const isNewTag = !currentTag.tagId;

        if(isNewTag){
            currentTag.users = currentTag.users.filter(tagUser => tagUser.email !== user.email);

            this.setState({ currentTag });
            return;
        }

        this.setState({ errorMessage: null, successMessage: null, confirmDialog: null, editingCurrentTagProp: EDITING_TAG_PROP.USERS });

        this.props.deleteTagUser(currentTag.tagId, user)
        .then((updatedTag) => {

            const updatedTagSubTags = this.state.tags.filter(tag => tag.ancestors.includes(updatedTag.tagId) && tag.tagId !== updatedTag.tagId);

            TagPermissions.removeTagFromUser(user, updatedTag, updatedTagSubTags);

            this.setState({ 
                currentTag: updatedTag,
                successMessage: strings.formatString(strings.tags_unassign_success, user.email, currentTag.name)
            });
        })
        .catch(err => {
            console.error("tagsPage: error removing user from tag", err);
            this.setState({ errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.UNASSIGN_USER, currentTag.name, user.email) });
        })
        .finally(() => {
            this.setState({ editingCurrentTagProp: EDITING_TAG_PROP.NONE });
        });
    }

    updateUserRoleInCurrentTag = (user, role) => {
        const currentTag = this.state.currentTag;
        const roleString = strings[`tags_role_${role.toLowerCase()}_label`];

        this.setState({ errorMessage: null, successMessage: null, confirmDialog: null, editingCurrentTagProp: EDITING_TAG_PROP.USERS });

        this.props.updateTagUser(currentTag.tagId, user, role)
        .then((updatedTag) => {

           TagPermissions.updateUserTagRole(user, updatedTag, role);
            this.setState({ 
                currentTag: updatedTag,
                successMessage: strings.formatString(strings.tags_user_role_update_success, user.email, roleString, currentTag.name)
            });
        })
        .catch(err => {
            console.error("tagsPage: error updating user role on tag", err);
            this.setState({ errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.CHANGE_USER_ROLE, user.email, roleString, currentTag.name) });
        })
        .finally(() => {
            this.setState({ editingCurrentTagProp: EDITING_TAG_PROP.NONE });
        });
    }

    addRavenToCurrentTag = (raven) => {
        const currentTag = this.state.currentTag;

        const isNewTag = !currentTag.tagId;

        if(isNewTag){
            currentTag.ravens.push({
                ravenUuid: raven.ravenUuid
            });

            this.setState({currentTag});
            return;
        }

        this.setState({ errorMessage: null, successMessage: null, editingCurrentTagProp: EDITING_TAG_PROP.RAVENS });

        this.props.addTagRaven(currentTag.tagId, raven)
        .then(([updatedTag]) => { // There should be only one tag in the array, because all the tag's ancestors should already have the raven

            TagPermissions.addTagsToRaven(raven, updatedTag);

            this.setState({
                currentTag: updatedTag,
                successMessage: strings.formatString(strings.tags_assign_success, raven.vehicle.name, currentTag.name)
            });
        })
        .catch(err => {
            console.error("tagsPage: error adding raven to tag", err);
            this.setState({ errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.ASSIGN_RAVEN, currentTag.name, raven.vehicle.name) });
        })
        .finally(() => {
            this.setState({ editingCurrentTagProp: EDITING_TAG_PROP.NONE });
        });

    }

    removeRavenFromCurrentTag = (raven) => {
        const currentTag = this.state.currentTag;

        const isNewTag = !currentTag.tagId;

        if(isNewTag){
            currentTag.ravens = currentTag.ravens.filter(tagRaven => tagRaven.ravenUuid !== raven.ravenUuid);
            this.setState({ currentTag });
            return;
        }

        this.setState({ errorMessage: null, successMessage: null, confirmDialog: null, editingCurrentTagProp: EDITING_TAG_PROP.RAVENS });

        this.props.deleteTagRaven(currentTag.tagId, raven)
        .then((updatedTags) => { // When a raven is removed from a tag, it's also removed from that tag's descendants (subtags)

            currentTag.ravens = currentTag.ravens.filter(tagRaven => tagRaven.ravenUuid !== raven.ravenUuid);

            TagPermissions.removeTagsFromRaven(raven, updatedTags);

            this.setState({ 
                currentTag,
                successMessage: strings.formatString(strings.tags_unassign_success, raven.vehicle.name, currentTag.name)
            });
        })
        .catch(err => {
            console.error("tagsPage: error removing raven from tag", err);
            this.setState({ errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.UNASSIGN_RAVEN, currentTag.name, raven.vehicle.name) });
        })
        .finally(() => {
            this.setState({ editingCurrentTagProp: EDITING_TAG_PROP.NONE });
        });
    }

    openAddTagModal = (parentTagId) => {

        
        // User clicks on the "+ Add Tag" button on the top right corner of the page
        if(!parentTagId){
            // Find the first tag with admin access level for the user
            let parentTag =  this.state.tags.find(tag => (tag.parentTagId === null || tag.isRootTag === true) && tag.canEdit);

            if(!parentTag){
                parentTag = this.state.tags.find(tag => tag.canEdit);
            }
            
            // user has no tag with admin access level
            // So they can't create a new tag
            if(!parentTag){
                return;
            }

            // new tag cannot have ravens that are not on its parent tag
            this.setAvailableRavens(parentTag.ravens);

            parentTagId = parentTag.tagId;
        }
        // User clicks on the "+ Add Sub Tag" button on a tag row
        else{
            const parentTag = this.state.tags.find(tag => tag.tagId === parentTagId);

            // This should not happen, but just in case
            if(!parentTag){
                return;
            }

            this.setAvailableRavens(parentTag.ravens);
        }

        this.props.addNewTag(parentTagId);

        this.resetMessages();

        this.setState({
            isActionModalOpen: true,
            editingCurrentTagProp: EDITING_TAG_PROP.ALL
        }, () => {
            this.sortRavensAndUsers();
        });
    }

    openEditTagModal = (tagId) => {

        this.props.editTag(tagId);

        const currentTag = this.state.tags.find(tag => tag.tagId === tagId);
        const parentTag = this.state.tags.find(tag => tag.tagId === currentTag.parentTagId);

        // The editing tag is not a first level tag (root tag "All" for owner)
        // Therefore the parent tag is also in the tags list
        // So, available ravens for editing tag are all ravens that are assigned to the parent tag
        if(parentTag){
            this.setAvailableRavens(parentTag.ravens);
        }
        // The editing tag is a first level tag (it's the root tag "All" or the user is not assigned to the parent tag)
        // Therefore the parent tag is not in the tags list
        // So, available ravens are all ravens that are assigned to the editing tag itself
        else {
            this.setAvailableRavens(currentTag.ravens);
        }
        
        this.resetMessages();

        this.setState({ 
            isActionModalOpen: true,
            editingCurrentTagProp: EDITING_TAG_PROP.NONE
        }, () => {            
            this.sortRavensAndUsers(currentTag);
        });
    }

    afterOpenModal = () => {
        if(this.usersListRef.current){
            const usersListElm = this.usersListRef.current;
            if (usersListElm.scrollHeight > usersListElm.clientHeight) {
                usersListElm.classList.add('scrollable');
            } else {
                usersListElm.classList.remove('scrollable');
            }
        }
    }

    openConfirmDeleteTagDialog = (tagId) => {
        const currentTag = this.state.tags.find(tag => tag.tagId === tagId);

        if(!currentTag){
            return;
        }

        const confirmDialog = <ConfirmDialog
                                isOpen={true}
                                onOk={() => this.deleteTag(currentTag)}
                                onCancel={this.closeConfirmDialog}
                                onDismiss={this.closeConfirmDialog}
                            >
                                <h4>{strings.tags_delete_tag_confirm_title}</h4>
                                <p>{strings.formatString(strings.tags_delete_tag_confirm_message, currentTag.name)}</p>
                            </ConfirmDialog>;
        
        this.setState({
            confirmDialog
        });
    }

    openConfirmDeleteUserDialog = (user, tag) => {
        if(!user){
            return;
        }

        const userPurelyInheritedTagsCount = user.tags.filter(userTag => userTag.userType &&  userTag.userType === TAG_USER_TYPES.INHERITED_USER).length;
        const userTagsCount = user.tags.length;
        const isLastTag = userTagsCount === 1 || (userTagsCount - userPurelyInheritedTagsCount) === 1;

        const confirmDialog = <ConfirmDialog
                                isOpen={true}
                                onOk={() => this.removeUserFromCurrentTag(user)}
                                onCancel={this.closeConfirmDialog}
                                onDismiss={this.closeConfirmDialog}
                            >
                                <h4>{strings.tags_unassign_tag_confirm_title}</h4>
                                <p>{strings.formatString(strings.tags_unassign_tag_confirm_message, tag.name, user.email)}</p>
                                {isLastTag && <p className='warning-message last-tag-warning'><i className='material-icons'>warning</i> <span>{strings.tags_user_last_tag_warning}</span></p>}
                            </ConfirmDialog>;
        
        this.setState({
            confirmDialog
        });
    }

    openConfirmUpdateUserRoleDialog = (user, role, tag) => {
        if(!user){
            return;
        }

        const roleString = strings[`tags_role_${role.toLowerCase()}_label`];
        const confirmDialog = <ConfirmDialog
                                isOpen={true}
                                onOk={() => this.updateUserRoleInCurrentTag(user, role)}
                                onCancel={this.closeConfirmDialog}
                                onDismiss={this.closeConfirmDialog}
                            >
                                <h4>{strings.tags_change_role_confirm_title}</h4>
                                <p>{strings.formatString(strings.tags_change_role_confirm_message, user.email, roleString, tag.name)}</p>
                            </ConfirmDialog>;
        
        this.setState({
            confirmDialog
        });
    }
    
    openConfirmDeleteRavenDialog = (raven, tag) => {
        if(!raven){
            return;
        }

        const confirmDialog = <ConfirmDialog
                                isOpen={true}
                                onOk={() => this.removeRavenFromCurrentTag(raven)}
                                onCancel={this.closeConfirmDialog}
                                onDismiss={this.closeConfirmDialog}
                            >
                                <h4>{strings.tags_unassign_tag_confirm_title}</h4>
                                <p>{strings.formatString(strings.tags_unassign_tag_confirm_message, tag.name, raven.vehicle.name)}</p>
                            </ConfirmDialog>;
        
        this.setState({
            confirmDialog
        });
    }

    closeActionModal = () => {
        this.props.cancel().then(() => {
            this.resetMessages();
            this.setState({ 
                isActionModalOpen: false, 
                currentTag: undefined,
                usersKeyword: '',
                ravensKeyword: ''
            });
            this.setData();
        });
    }

    cancelNewTag = () => {
       this.closeActionModal();
    }

    closeConfirmDialog = () => {
        this.setState({ 
            confirmDialog: null
        });
    }

    validateTag = (tag) => {
        const validationErrors = [];

        const tagName = tag.name ? tag.name.trim() : '';

        if(!tagName){
            validationErrors.push({field: 'name', message: strings.tags_validation_name_required});
        }
        else if(tagName.length > 50){            
            validationErrors.push({field: 'name', message: strings.tags_validation_name_max_length});
        }
        else if(this.state.tags.some(t => t.name.toLowerCase() === tagName.toLowerCase() && t.tagId !== tag.tagId)){
            validationErrors.push({field: 'name', message: strings.tags_validation_name_unique});
        }
        
        this.setState({validationErrors});

        if(validationErrors.length > 0){
            return false;
        }

        tag.name = tagName;

        return true;
    }

    saveNewTag = () => {
        
        if(!this.validateTag(this.state.currentTag)){
            return;
        }
        
        this.resetMessages();
        
        this.props.saveNewTag(this.state.currentTag)
        .then((newTag) => {
            const successMessage = strings.formatString(strings.tags_save_new_success, newTag.name);

            const tags = [...this.state.tags, newTag];
            const ravens = this.state.ravens;
            const users = this.state.users;

            TagPermissions.addNewTagToRavens(newTag, ravens);

            TagPermissions.addNewTagToUsers(newTag, users);

            this.setState({ 
                isActionModalOpen: false, 
                currentTag: undefined,                
                usersKeyword: '',
                ravensKeyword: '',
                successMessage,
                ravens, 
                users,
                tags
            });
        })
        .catch((err) => {
            console.error("tagsPage: error saving tag", err);
            this.setState({errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.ADD)});
        })
        .finally(() => {
            this.setData();
        });
    }

    deleteTag = (tag) => {

        this.resetMessages();
        this.closeConfirmDialog();

        this.props.deleteTag(tag.tagId)
        .then(() => {            
            const successMessage = strings.formatString(strings.tags_delete_tag_success, tag.name);
            
            const tags = this.state.tags.filter(t => t.tagId !== tag.tagId);
            const filteredTags = this.filterTags(tags, this.state.filters);
            const ravens = this.state.ravens;
            const users = this.state.users;

            TagPermissions.removeDeletedTagFromRavens(tag, ravens);

            TagPermissions.removeDeletedTagFromUsers(tag, users);            

            this.setState({successMessage, tags, filteredTags, ravens, users});
        })
        .catch((err) => {
            console.error("tagsPage: error deleting tag", err);
            this.setState({errorMessage: TagsUtil.getErrorMessage(err, TAG_ACTIONS.DELETE)});
        });
    }

    resetMessages = () => {
        this.setState({errorMessage: '', successMessage: '', validationErrors: []});
    }

    clearDefaultTagName = (e) => {
        if(e.target.value === strings.tags_new_tag_default_name){
            this.setState({currentTag: {...this.state.currentTag, name: ''}});
        }
    }

    renderActionModal = () => {
        const currentTag = this.state.currentTag;
        
        if(!currentTag){
            return null;
        }

        const tagsAsParent = this.state.tags.filter(tag => tag.tagId !== currentTag.tagId);
        
        const parentTag = tagsAsParent.find(tag => tag.tagId === currentTag.parentTagId);

        const ravens = this.filterRavens();
        const users = this.filterUsers();

        const hasInheritedUsers = currentTag.users.some(tagUser => tagUser.type !== TAG_USER_TYPES.OWN_USER);
        
        const isNewTag = !currentTag.tagId;
        const isASystemTag = currentTag.type === TAG_TYPES.SYSTEM;
        const isTheRootTag = !currentTag.parentTagId || currentTag.isRootTag; // Is it the accounts root tag ("All" tag). Ravens cannot be unassigned from this tag

        const showParentTagLabel = !isNewTag && parentTag; // Once a tag is created, it cannot be moved to another parent tag, so we just show the parent tag's name (if it has one)
        const showTagsHierarchy = isNewTag; // If it's a new tag, we show the tags hierarchy so the user can select a parent tag
        const canEditType = currentTag.parentTagId ? true : false; // Type can't be edited only for the root tag of the account ("All" tag)

        const expandedKeys = [];
        if(currentTag.ancestors.length > 1){
            expandedKeys.push(...currentTag.ancestors);
        }

        const thereAreMessages = this.state.errorMessage || this.state.successMessage || this.state.validationErrors.length > 0;

        return (
            <Modal 
                isOpen={this.state.isActionModalOpen}
                onAfterOpen={this.afterOpenModal}
                className="tag-action-modal react-modal-content react-modal"
                overlayClassName="react-modal-overlay"
                shouldCloseOnOverlayClick={false}
                onRequestClose={() => isNewTag ? this.cancelNewTag() : this.closeActionModal()}
            >
                <div className="container">
                    <div className="row header">
                        <div className='col-7'>
                            <h2>{isNewTag ? strings.tags_new_tag_modal_title : strings.tags_edit_tag_modal_title}</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-12 messages ${thereAreMessages ? 'visible' : 'invisible'}`}>
                            {this.state.successMessage && <div className='success-message'>{this.state.successMessage}</div>}

                            <ul className='errors'>
                                {this.state.errorMessage && <li className='error-message'>{this.state.errorMessage}</li>}
                                {this.state.validationErrors.map(error => {
                                    return <li className='error-message'>{error.message}</li>
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-12'>
                            <div className='row'>
                                
                                <div className='col-3'>
                                    <label htmlFor='name'>{strings.tags_name_label}</label>
                                    {isNewTag ? 
                                        <input type="text" name="name" onFocus={this.clearDefaultTagName} id="tag-name" value={currentTag.name} onChange={(e) => this.updateCurrentTagName(e.target.value)} />
                                    :
                                    <>
                                        <EditableLabel
                                            name="name"
                                            id="tag-name"
                                            value={currentTag.name}
                                            editing={this.state.editingCurrentTagProp === EDITING_TAG_PROP.NAME}
                                            onRequestEdit={() => this.requestEditingProp(EDITING_TAG_PROP.NAME)}
                                            onCancel={this.cancelEditingProp}
                                            onChange={this.updateCurrentTagName}
                                            loading={false}
                                            maxLength={50}
                                        />
                                        {this.props.tagPropPending && this.state.editingCurrentTagProp === EDITING_TAG_PROP.NAME && <ProgressOverlay />}
                                    </>
                                    }
                                </div>

                                <div className='col-3'>
                                    <label htmlFor='type'>
                                        {strings.tags_type_label}
                                        {!canEditType && <InfoTooltip message={strings.tags_root_tag_type_not_editable} />}
                                    </label>
                                    {(this.state.editingCurrentTagProp === EDITING_TAG_PROP.ALL ||  this.state.editingCurrentTagProp === EDITING_TAG_PROP.TYPE) ?
                                        <div className="tag-editing-prop">
                                            <TagTypesDropDown 
                                                includeSystemType={isASystemTag} 
                                                name="type"
                                                id="tag-type"
                                                disabled={!canEditType}
                                                showOptionForAll={false}
                                                selectedItems={currentTag.type}
                                                multipleSelection={false}
                                                onChange={this.updateCurrentTagType}
                                                closeOnChange={true}
                                                required
                                            />
                                            {this.state.editingCurrentTagProp === EDITING_TAG_PROP.TYPE &&
                                                <button onClick={this.cancelEditingProp}>
                                                    <i className="material-icons">close</i>
                                                </button>
                                            }
                                            {this.props.tagPropPending && this.state.editingCurrentTagProp === EDITING_TAG_PROP.TYPE && <ProgressOverlay />}
                                        </div>
                                    :
                                        <div className='tag-editable-prop' >
                                            <span name="type" id="tag-type">{strings[`tags_type_${TAG_TYPES[currentTag.type].toLowerCase()}_label`]}</span>
                                            {canEditType && 
                                                <button  onClick={() => this.requestEditingProp(EDITING_TAG_PROP.TYPE)}>
                                                    <i className="material-icons">edit</i>
                                                </button>
                                            }
                                        </div>
                                    }
                                </div>

                                {showParentTagLabel &&
                                    <div className='col-3'>
                                        <label htmlFor='parent'>{strings.tags_parent_label}<InfoTooltip message={strings.tags_parent_not_editable} /></label>
                                        <div className='tag-readonly-prop' name="parent" id="tag-parent">{parentTag.name}</div>
                                    </div>
                                }
                                
                                <div className='col-3 col-lg-2'>
                                    <label htmlFor='color'>{strings.tags_color_label}</label>
                                    <Color
                                        name="color"
                                        id="tag-color"
                                        value={currentTag.style.color}
                                        showLabel={false}
                                        onChange={this.updateCurrentTagColor}
                                        colors={TAG_COLORS}
                                        parentElmSelector={'.tag-action-modal'}
                                    />
                                    { this.props.tagPropPending && this.state.editingCurrentTagProp === EDITING_TAG_PROP.COLOR && <ProgressOverlay />}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-lg-3">

                        {showTagsHierarchy &&
                         <div className='col-12 col-lg-4 mt-5 mt-lg-0'>
                            <label htmlFor='parent'>{strings.tags_parent_label}</label>
                            <TagsTreeView
                                name="parent"
                                id="tag-parent"
                                tags={tagsAsParent} 
                                expandedTagsIds={expandedKeys}
                                selectedTagsIds={[currentTag.parentTagId]} 
                                multipleSelection={false}
                                onChange={this.updateCurrentTagParent}
                                disableGuestTags
                                hideFilterByType
                                showTooltips
                                compact
                            />
                        </div>
                        }

                        <div className={`col-12 ${showTagsHierarchy ? 'col-lg-3' : 'col-lg-5'} mt-5 mt-lg-0`}>
                            <label htmlFor='ravens'>
                                {strings.tags_ravens_label}
                                {isTheRootTag && <InfoTooltip message={strings.tags_cant_unassign_ravens_from_root_tag} />}
                            </label>
                            
                            <input type="text" className='filter' placeholder={strings.placeholder_filter} value={this.state.ravensKeyword} onChange={(e) => this.setState({ravensKeyword: e.target.value})} />
                            <div className='list-for-selecting ravens-list'>
                                {ravens.map(raven => {
                                    return <Raven key={raven.ravenUuid} raven={raven} disabled={isTheRootTag} currentTag={currentTag} onSelectionChange={this.onRavenSelectionChangeHandler} />
                                })}
                                { this.props.tagPropPending && this.state.editingCurrentTagProp === EDITING_TAG_PROP.RAVENS && <ProgressOverlay />}
                            </div>
                        </div>

                        <div className={`col-12 ${showTagsHierarchy ? 'col-lg-5' : 'col-lg-7'} mt-5 mt-lg-0`}>
                            <label htmlFor='users'>{strings.tags_users_label}</label>
                            <input type="text" className='filter' placeholder={strings.placeholder_filter} value={this.state.usersKeyword} onChange={(e) => this.setState({usersKeyword: e.target.value})} />
                            
                            <div className='list-for-selecting users-list' ref={this.usersListRef}>
                                {users.map(user => {
                                    return <User isCurrentUser={user.email === this.props.user.email} key={user.email} user={user} currentTag={currentTag} onUserRoleChange={this.onUserRoleChangeHandler} onUserSelectionChange={this.onUserSelectionChangeHandler} />
                                })}
                                { this.props.tagPropPending && this.state.editingCurrentTagProp === EDITING_TAG_PROP.USERS && <ProgressOverlay />}
                            </div>
                        </div>

                    </div>
                    <div className='row'>

                        <div className="col-12 actions">
                            {isNewTag ?
                                <>
                                <button className="btn btn-outline-blue" onClick={this.cancelNewTag}><i className="material-icons">close</i>{strings.action_cancel}</button>
                                <button className="btn btn-blue" onClick={this.saveNewTag}><i className="material-icons">check</i>{strings.action_save}</button>
                                </>
                            :
                                <button className="btn btn-outline-blue" onClick={this.closeActionModal}><i className="material-icons">close</i>{strings.app_close}</button>
                            }
                        </div>
                    </div>
                </div>
                {this.props.tagsPending && isNewTag && <ProgressOverlay />}
            </Modal>
        );
    }
    
    sortRavensAndUsers = (tag) => {
        let tagRavens = [];
        let tagUsers = [];

        if(tag){
            tagRavens = tag.ravens;
            tagUsers = tag.users
        }
        
        const tagRavensUuids = tagRavens.map(tagRaven => tagRaven.ravenUuid);

        // sort ravens so that the ones that are assigned to the tag are at the top
        this.state.availableRavens.sort((a, b) => {
            const aInTag = tagRavensUuids.includes(a.ravenUuid);
            const bInTag = tagRavensUuids.includes(b.ravenUuid);

            if (aInTag && !bInTag) return -1;
            if (!aInTag && bInTag) return 1;
            return 0;
        });

        const tagUsersEmails = tagUsers.map(tagUser => tagUser.email);

        // sort users so that the ones that are assigned to the tag are at the top
        this.state.users.sort((a, b) => {
            const aInTag = tagUsersEmails.includes(a.email);
            const bInTag = tagUsersEmails.includes(b.email);

            if (a.isOwner && !b.isOwner) return -1;
            if (!a.isOwner && b.isOwner) return 1;
            if (a.isCurrentUser && !b.isCurrentUser) return -1;
            if (!a.isCurrentUser && b.isCurrentUser) return 1;
            if (aInTag && !bInTag) return -1;
            if (!aInTag && bInTag) return 1;
            return a.email.localeCompare(b.email);
        });
    }

    filterRavens = () => {

        if(!this.state.availableRavens){
            return [];
        }

        if(!this.state.ravensKeyword){
            return this.state.availableRavens;
        }
 
         return this.state.availableRavens.filter(raven => raven.vehicle.name.toLowerCase().includes(this.state.ravensKeyword.toLowerCase()));
    }
 
    filterUsers = () => {
        
         if(!this.state.users){
             return [];
         }

         if(!this.state.usersKeyword){
             return this.state.users;
         }
 
         return this.state.users.filter(user => user.email.toLowerCase().includes(this.state.usersKeyword.toLowerCase()));
    }

    setListFilters = (filterId, value) => {
        let filters = [...this.state.filters];

        const indexOfFilter = filters.findIndex(filter => filter.id === filterId);

        if(filterId === 'name') {
            if(indexOfFilter > -1){
                if(value)
                    filters[indexOfFilter] = {id: filterId, value};
                else
                    filters = filters.filter(filter => filter.id !== filterId);
            }else{
                if(value)
                    filters = [...filters, {id: filterId, value}];
            }
        }

        if(filterId === 'type') {
            if(indexOfFilter > -1){
                if(value.length > 0)
                    filters[indexOfFilter] = {id: filterId, value};
                else
                    filters = filters.filter(filter => filter.id !== filterId);
            }else{
                if(value.length > 0)
                    filters = [...filters, {id: filterId, value}];
            }
        }

        const filteredTags = this.filterTags(this.state.tags, filters);
        const expanded = this.getExpanded(filteredTags, filters);

        this.setState({ filters, filteredTags, expanded});
    }

    filterTags = (tags = this.state.tags, filters = this.state.filters) => {
        if(!tags){
            return [];
        }

        if(filters.length === 0){
            tags.forEach(tag => delete tag.matchedFilters);
            return TagsUtil.convertToHierarchy(tags);
        }

        const list = [];

        const nonEmptyFilters = filters.filter(filter => 
            filter.value !== undefined && 
            filter.value !== null &&
            (typeof filter.value === 'string' ? filter.value !== '' : true) && 
            (Array.isArray(filter.value) ? filter.value.length > 0 : true)
        );

        if(nonEmptyFilters.length === 0){
            tags.forEach(tag => delete tag.matchedFilters);
            return TagsUtil.convertToHierarchy(tags);
        }

        tags.forEach(tag => {
            const tagMatchesAllFilters = nonEmptyFilters.every(filter => {
                switch (true){
                    case typeof filter.value === 'string':
                        return tag[filter.id].toLowerCase().includes(filter.value.toLowerCase());
                    case Array.isArray(filter.value):
                        return filter.value.includes(tag[filter.id]);
                    default:
                        return false;
                }
            });

            if(tagMatchesAllFilters){
                tag.matchedFilters = true;

                list.push(tag);

                if(tag.parentTagId){
                    TagsUtil.includeTagAncestorsInList(tag, list, this.state.tags);
                }
            }
            else{
                delete tag.matchedFilters;
            }
        });

        return TagsUtil.convertToHierarchy(list);
    }

    setExpanded = (expanded) => {
        if(this.state.isActionModalOpen) return;

        this.setState({expanded});
    }

    getExpanded = (list, filters) => {

        function addToExpanded(tags, parentExpandedObj){

            tags.forEach((tag, index) => {
                
                if(tag.childTags){
                    parentExpandedObj[index] = addToExpanded(tag.childTags, {});
                }
                else{
                    parentExpandedObj[index] = true;
                }
            });

            return parentExpandedObj;
        }

        const expanded = {};

        // When no filters, state.expanded reset to original state (root tags being expanded)
        if(filters.length === 0){
            const rootTags = list.filter(tag => tag.isRootTag);
            rootTags.reduce((acc, tag, index) => {
                acc[index] = {};
                return acc;
            }, expanded);
        }
        // Else, we expand all rows
        // The idea is, when filtering happens, the list we have, they all are the tags that match the filter
        // And as it's a nested list, we need to expand all rows to show the matched tags that are nested
        // To do that, we need to create a nested object with the same structure as the list
        // and set all values to true
        /* {
            0: {
                  0:{
                      0: true,
                      1: true
                     }, 
                   1: true
                }, 
            1: true
            }
        */
        // https://www.npmjs.com/package/react-table/v/6.8.6#fully-controlled-component
        else {
            addToExpanded(list, expanded);
        }

        return expanded;
    }

    onUserRoleChangeHandler = (user, role) => {
        const currentTag = {...this.state.currentTag};
        const currentTagUsers = currentTag.users;

        const isNewTag = !currentTag.tagId;

        // If it's a new tag, we just update the user's role in the current tag
        if(isNewTag){
            const currentTagUser = currentTagUsers.find(tagUser => tagUser.email === user.email);
            if(currentTagUser){

                currentTagUser.role = role;

                if(currentTagUser.type === TAG_USER_TYPES.INHERITED_USER){
                    currentTagUser.type = TAG_USER_TYPES.SHARED_USER;
                }

                this.setState({currentTag});
            }
            return;
        }

        // If it's an existing tag, before updating the user's role show a confirmation dialog
        this.openConfirmUpdateUserRoleDialog(user, role, currentTag);
    }

    onUserSelectionChangeHandler = (user) => {
        const currentTag = this.state.currentTag;
        const currentTagUsers = currentTag.users;

        const isNewUser = currentTagUsers.every(tagUser => tagUser.email !== user.email);
        const isNewTag = !currentTag.tagId;

        // It's a new user so we just add it to the current tag
        if(isNewUser){
            this.addUserToCurrentTag(user);
            return;
        }

        // It's an existing user so we remove it from the current tag

        // If it's a new tag, we just remove the user from the current tag
        if(isNewTag){
            this.removeUserFromCurrentTag(user);
            return;
        }

        // If it's an existing tag, before removing the user show a confirmation dialog
        this.openConfirmDeleteUserDialog(user, currentTag);
    }

    onRavenSelectionChangeHandler = (raven) => {
        const currentTag = this.state.currentTag;
        const currentTagRavens = currentTag.ravens;

        const isNewTag = !currentTag.tagId;
        const isNewRaven  = currentTagRavens.findIndex(tagRaven => tagRaven.ravenUuid === raven.ravenUuid) === -1;

        // It's a new raven so we just add it to the current tag
        if(isNewRaven){
            this.addRavenToCurrentTag(raven);
            return;
        }

        // It's an existing raven so we remove it from the current tag

        // If it's a new tag, we just remove the raven from the current tag
        if(isNewTag){
            this.removeRavenFromCurrentTag(raven);
            return;
        }

        // If it's an existing tag, before removing the raven show a confirmation dialog
        this.openConfirmDeleteRavenDialog(raven, currentTag);
    }

    renderStats = () => {

        const list = this.state.tags;

        const stats = {};

        for(let type in TAG_TYPES){
            stats[type] = list.filter(t => t.type === type).length;
        }

        const total = list.length;
        const totalLabel = strings.stats_total_label;

        return (
            <div className='col-12 stats'>
                <div><label>{totalLabel}: </label><span>{total}</span></div>
                {Object.keys(stats).map(key => {
                    return <div key={key}><label>{strings[`tags_type_${key.toLowerCase()}_label`]}: </label><span>{stats[key]}</span></div>
                })}
            </div>
        );
    }

    isContentReady = () => {

        const {tagsLoading, tagsError, usersError} = this.props;

        if(tagsLoading || tagsError || usersError || !this.state.dataSet){
            return false;
        }

        return true;
    }

    renderContentLoadingStatus = () => {
        let issue = null;

        // There is no error, no pending and no loaded tags. So, can conclude Tags are not enabled.
        const tagsNotEnabled = !this.props.tagsLoaded && !this.props.tagsLoading && !this.props.tagsError;


        if(tagsNotEnabled){
            issue = <div className='error-message'>{strings.tags_not_enabled}</div>;
        }
        else if(this.props.tagsError || this.props.usersError){
            issue = <div className='error-message'><i className="material-icons">error_outline</i>{strings.tags_loading_tags_error}</div>;
        }
        else if(this.props.tagsLoading || !this.state.dataSet){
            issue = <div className='loading-data'><ProgressSpinnerSmall/><div>{strings.tags_loading_tags}</div></div>;
        }

        return issue;
    }

    render() {

        const isContentReady = this.isContentReady();

        const inProgress = this.props.tagsPending;
        const hasSystemTag = this.state.tags && this.state.tags.some(tag => tag.type === TAG_TYPES.SYSTEM);

        return (
            <div id="tagsPage" className='container account-page'>
                <div className='row'>
                    <div className='col-8'>
                        <h1>{strings.tags_page_title}</h1>
                    </div>
                    <div className='col-4 d-flex align-items-center justify-content-end'>
                        <button className="btn btn-blue" onClick={() => this.openAddTagModal()}>{strings.tags_add_tag_label}</button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        {this.state.successMessage && !this.state.isActionModalOpen && <div className='success-message'>{this.state.successMessage}</div>}
                        {this.state.errorMessage && !this.state.isActionModalOpen && <div className='error-message'>{this.state.errorMessage}</div>}
                    </div>
                </div>
                {isContentReady ?
                    <>
                        <div className='row'>
                            {this.renderStats()}
                        </div>
                        <div className='row'>
                            <div className='col-8 instructions'>
                                <div>{strings.tags_click_to_see_sub_tags}</div>
                                <div>{strings.formatString(strings.tags_click_to_manage_tag, <i className="material-icons tag-edit-icon">edit</i>)}</div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>
                                
                                <TagsTable
                                    tags={this.state.filteredTags}
                                    openAddTagModal={this.openAddTagModal}
                                    openEditTagModal={this.openEditTagModal}
                                    openConfirmDeleteTagDialog={this.openConfirmDeleteTagDialog}
                                    filters={this.state.filters}
                                    setListFilters={this.setListFilters}
                                    expanded={this.state.expanded}
                                    setExpanded={this.setExpanded}
                                    hasSystemTag={hasSystemTag}
                                />

                                {this.state.isActionModalOpen && this.renderActionModal()}
                                
                                {this.state.confirmDialog}
                            </div>
                        </div>
                        {inProgress && !this.state.isActionModalOpen && <ProgressOverlay />}
                    </>
                :
                    <div className='row'>
                        <div className='col-12'>
                            {this.renderContentLoadingStatus()}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

class TagsTable extends PureComponent {
    
    constructor(props){
        super(props);

        this.state = {
            columns: this.getColumns(),
        }
    }

    newColumn = (header, accessor, overrides = {} ) => {
        return {
            Header: strings[`tags_${header}_label`],
            accessor: accessor,
            Placeholder: strings.formatString(strings.reports_header_filter_x_names, strings.tag_label),
            filterable: false,
            className: 'react-table-column',
            headerClassName: 'react-table-column',
            ...overrides
        }
    }

    getColumns = () => {

        const columns = [
            this.newColumn('name', 'name',
            {
                filterable: true,
                expander: true,
                className: 'react-table-grow-column',
                headerClassName: 'react-table-grow-column',
                Expander: row => {
                    const marginLeft = row.original.isLeaf ? (SUBTAGS_ARROW_WIDTH * (row.level + 1)) + "px" : (SUBTAGS_ARROW_WIDTH * (row.level)) + "px";
                    const canAddSubTag = row.original.canEdit; // user must have write access to the tag to be able to add a sub-tag

                    return <div className='tag-name' style={{marginLeft: `${marginLeft}`}}>
                                {!row.original.isLeaf && <ReactTable.defaultProps.ExpanderComponent {...row} />}
                                <span className={row.original.matchedFilters ? 'matched-filters': ''}>{row.original.name}</span>
                                {canAddSubTag && <button className='btn btn-outline-transparent' onClick={(e) => this.props.openAddTagModal(row.original.tagId)}>{strings.tags_add_sub_tag_label}</button>}
                            </div>;
                    
                }
            }),
            this.newColumn('name', 'name', {show: false}),
            this.newColumn('type', 'type',
            {
                className: 'react-table-column d-none d-md-block',
                headerClassName: 'react-table-column d-none d-md-block',
                width: 200,
                filterable: true,
                Filter: ({filter, onChange}) => {
                    return (
                        <TagTypesDropDown
                            includeSystemType={this.props.hasSystemTag}
                            selectedItems={filter ? filter.value : []}
                            onChange={selectedItems => onChange(selectedItems)}
                            className='react-table-header-filter'
                            multipleSelection
                        />
                    );                            
                },
                Cell: props => <span>{strings[`tags_type_${props.value.toLowerCase()}_label`]}</span>,
            }),
            this.newColumn('color', 'style.color',
            {                        
                className: 'react-table-column d-none d-xl-block',
                headerClassName: 'react-table-column d-none d-xl-block',
                Cell: props => <div className='tag-color' style={{backgroundColor: `${props.value}`}}>&nbsp;</div>
            }),
            this.newColumn('subtags', 'childTags',
            {
                className: 'react-table-column d-none d-lg-block',
                headerClassName: 'react-table-column d-none d-lg-block',
                Cell: props => <span>{props.value ? props.value.length : 0}</span>,
            }),
            this.newColumn('ravens', 'ravens',
            {
                className: 'react-table-column d-none d-lg-block',
                headerClassName: 'react-table-column d-none d-lg-block',
                Cell: props => <span>{props.value.length}</span>,
            }),
            this.newColumn('users', 'users',
            {        
                className: 'react-table-column d-none d-lg-block',
                headerClassName: 'react-table-column d-none d-lg-block',
                Cell: props => <span>{props.value.length}</span>,
            }),
            this.newColumn('', 'tagId',
            {
                width: 32,
                Cell: (row) => {
                    const disabled = !row.original.canEdit;

                    return <button disabled={disabled} className='btn-icon btn-outline-transparent' onClick={() => this.props.openEditTagModal(row.original.tagId)}><i className="material-icons tag-edit-icon">edit</i></button>
                }
            }),
            this.newColumn('', 'tagId',
            {
                width: 32,
                Cell: (row) => {
                    const disabled = !row.original.isLeaf || // Has children
                                    !row.original.parentTagId || // Is account's original root tag (All tag)
                                    row.original.isRootTag || // Is root tag for current user
                                    !row.original.canEdit; // User is not Admin on tag

                    return <button disabled={disabled} className='btn-icon btn-outline-transparent' onClick={() => this.props.openConfirmDeleteTagDialog(row.original.tagId)}><i className="material-icons tag-edit-icon">delete</i></button>
                }
            })
        ];

        return columns;
    }

    render() {   
        
        return (
            <ReactTable
                filterable={true}
                sortable={false}
                showPagination = {false}
                minRows = {0}
                data={this.props.tags}
                noDataText={strings.no_match_for_selected_filters}
                expanded={this.props.expanded}
                filtered={this.props.filters}
                subRowsKey="childTags"
                defaultFilterMethod={(filter, row) => {
                    return true;
                }}
                columns={this.state.columns}                
                onFilteredChange={(filtered, column, value) => {
                    this.props.setListFilters(column.id, value);
                }}

                onExpandedChange={(newExpanded, index, event) => {
                    this.props.setExpanded(newExpanded);
                }}

                getTrProps={(state, rowInfo, column) => {
                    if(rowInfo && rowInfo.level === 0)
                        return { className: '-rollup' };
                    return { className: '-padRow'};
                }}

                expanderDefaults={{
                    resizable: true,
                    width: 100
                }}
            />
        );
    }
}

class User extends Component {

    render() {
        const {user, isCurrentUser, currentTag} = this.props;

        const tagUser = currentTag.users.find(tagUser => tagUser.email === user.email);
        const checkboxIcon = tagUser ? 'check_box': 'check_box_outline_blank';
        const className = tagUser ? 'checked' : 'unchecked';

        let isInheritedUser = false;
        let canBeUnassigned = true;
        let canChangeRole = true;
        let role = TAG_USER_ROLES.GUEST;

        if((tagUser && [TAG_USER_TYPES.INHERITED_USER, TAG_USER_TYPES.SHARED_USER].includes(tagUser.type))){
            isInheritedUser = true;
        }

        // These users can't be removed from a tag
        // Current user
        // Inherited user
        if(isCurrentUser || isInheritedUser){
            canBeUnassigned = false;
        }

        // These users can't have their role changed
        // Current User
        // Inherited user with Admin role (can't make adming of parent tag a guest on a subtag)
        if(isCurrentUser ||  (isInheritedUser && tagUser.inheritedRole === TAG_USER_ROLES.ADMIN)){
            canChangeRole = false;
        }

        if(tagUser){
            const ownRole = tagUser.role;
            const inheritedRole = tagUser.inheritedRole;

            if(ownRole === TAG_USER_ROLES.ADMIN || inheritedRole === TAG_USER_ROLES.ADMIN){
                role = TAG_USER_ROLES.ADMIN;
            }
        }
        
        let tooltip = '';

        if(isCurrentUser || isInheritedUser || !canChangeRole){
            if(isCurrentUser){
                tooltip = strings.tags_cant_unassign_current_user;
            }
            else if(isInheritedUser){
                if(canChangeRole){
                    tooltip = strings.tags_cant_unassign_inherited_user_but_can_promote;
                }
                else {
                    tooltip = strings.tags_cant_edit_inherited_user;
                }
            }
        }

        return <div className={`list-item-for-selecting ${isInheritedUser ? 'inherited-user' : ''}`} data-email={user.email}>
                    <button disabled={!canBeUnassigned} onClick={() => this.props.onUserSelectionChange(user)} className='btn btn-outline-transparent'>
                        <i className={`material-icons selection-icon ${className}`}>{checkboxIcon}</i>
                        <span>{user.email} </span>
                    </button>
                    <div className={`tag-role ${tagUser ? 'visible' : 'invisible'}`}>
                        <TagRolesDropDown showOptionForAll={false} disabled={!canChangeRole} value={role} onChange={(e) => this.props.onUserRoleChange(user, e.target.value)} />
                    </div>
                    {tooltip && <InfoTooltip message={tooltip} for={`[data-email="${user.email}"]`} position="bottom left" noIcon />}
                </div>
    }
}

class Raven extends Component {
    render() {
        const {raven, currentTag} = this.props;
        
        const checked = currentTag.ravens.find(tagRaven => tagRaven.ravenUuid === raven.ravenUuid);
        const checkboxIcon = checked ? 'check_box': 'check_box_outline_blank';
        const className = checked ? 'checked' : 'unchecked';
        const tooltip = this.props.disabled ? strings.tags_cant_unassign_ravens_from_root_tag : '';

        return <div className='list-item-for-selecting' data-ravenid={raven.ravenUuid}>
                    <button disabled={this.props.disabled} onClick={() => this.props.onSelectionChange(raven)} className='btn btn-outline-transparent'>
                        <i className={`material-icons selection-icon ${className}`}>{checkboxIcon}</i>
                        {raven.vehicle.name}
                    </button>
                    {tooltip && <InfoTooltip message={tooltip} for={`[data-ravenid="${raven.ravenUuid}"]`} position="bottom left" noIcon />}
                </div>
        
    }
}

const mapStateToProps = state => {
    return {
        editingTag: Selectors.editingTag(state),
        tagPropPending: Selectors.tagPropChangePending(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        addNewTag: (parentTagId, user) => dispatch(DispatchHelpers.addNewTag(parentTagId, user)),
        editTag: (tagId) => dispatch(DispatchHelpers.startTagEdit(tagId)),
        saveNewTag: (tag) => dispatch(DispatchHelpers.saveTagEdit(tag)),
        deleteTag: (tagId) => dispatch(DispatchHelpers.deleteTag(tagId)),
        cancel: () => dispatch(DispatchHelpers.cancelTagEdit()),
        updateTagName: (tagId, name) => dispatch(DispatchHelpers.updateTagName(tagId, name)),
        updateTagType: (tagId, tagType) => dispatch(DispatchHelpers.updateTagType(tagId, tagType)),
        updateTagColor: (tagId, color) => dispatch(DispatchHelpers.updateTagColor(tagId, color)),
        deleteTagUser: (tagId, user) => dispatch(DispatchHelpers.deleteTagUser(tagId, user)),
        addTagUser: (tagId, user, role) => dispatch(DispatchHelpers.addTagUser(tagId, user, role)),
        updateTagUser: (tagId, user, role) => dispatch(DispatchHelpers.updateTagUser(tagId, user, role)),        
        deleteTagRaven: (tagId, raven) => dispatch(DispatchHelpers.deleteTagRaven(tagId, raven)),
        addTagRaven: (tagId, raven) => dispatch(DispatchHelpers.addTagRaven(tagId, raven)),
    }

};

export default connect(mapStateToProps, mapDispatchToProps)(TagsPage);